class ShippingEligibility extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.select = this.querySelector('select');
    this.result = this.querySelector('[data-result]');

    if (!this.form || !this.select || !this.result) return;

    this.allowed = this.parseList(this.dataset.allowed);
    this.blocked = this.parseList(this.dataset.blocked);
    this.restricted = this.parseList(this.dataset.restricted);

    this.form.addEventListener('submit', this.check);
    this.select.addEventListener('change', this.check);
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.check);
    this.select?.removeEventListener('change', this.check);
  }
  parseList(value) {
    return (value || '')
      .split(',')
      .map((code) => code.trim().toUpperCase())
      .filter(Boolean);
  }

  check = (event) => {
    event.preventDefault();

    const state = this.select.value;
    if (!state) {
      this.render('', '');
      return;
    }

    const name = this.select.options[this.select.selectedIndex].text;

    const notAllowed = this.allowed.length > 0 && !this.allowed.includes(state);

    if (notAllowed || this.blocked.includes(state)) {
      this.render('blocked', (this.dataset.messageBlocked || '').replace('[state]', name));
    } else if (this.restricted.includes(state)) {
      this.render('restricted', (this.dataset.messageRestricted || '').replace('[state]', name));
    } else {
      this.render('ok', (this.dataset.messageOk || '').replace('[state]', name));
    }
  };

  render(status, message) {
    this.result.textContent = message;
    this.result.hidden = !message;
    this.result.dataset.status = status;
  }
}

if (!customElements.get('shipping-eligibility')) {
  customElements.define('shipping-eligibility', ShippingEligibility);
}
